<template>
  <div class="flex h-[74px] justify-between items-center self-stretch pe-8">
    <div class="breadcrumbs text-xs text-neutral-500">
      <ul>
        <li><RouterLink to="/">Root</RouterLink></li>

        <li v-if="auth.user?.is_superuser">
          <RouterLink :to="{ name: 'Dashboard' }">Dashboard</RouterLink>
        </li>

        <li v-for="(crumb, index) in breadcrumbs" :key="index">
          <RouterLink v-if="crumb.to" :to="crumb.to">{{ crumb.name }}</RouterLink>
          <template v-else>{{ crumb.name }}</template>
        </li>
      </ul>
    </div>

    <div class="flex items-center gap-4">
      <NotificationButton />

      <ProfileButton
        :name="auth.user?.full_name ?? auth.user?.username"
        :id="auth.user?.id"
        :role="auth.user?.role || (auth.user?.is_superuser ? 'Admin' : 'User')"
        :image="auth.user?.avatar"
        @logout="handleLogout"
        @editProfile="handleEditProfile"
      />
    </div>
  </div>
</template>

<script setup>
import ProfileButton from "@/components/atoms/ProfileButton.vue";
import NotificationButton from "@/components/atoms/NotificationButton.vue";
import { useAuthStore } from "@/stores";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { showWarning } from "@/common/functions.js";

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const breadcrumbs = computed(() =>
  route.matched
    .filter((r) => {
      if (r.meta?.breadcrumb === false) return false;
      if (r.meta.allowedUserType && !auth.user?.is_superuser) return false;
      return true;
    })
    .map((r) => ({
      name: r.meta.breadcrumb || r.name,
      to: route.name === r.name ? null : r.path,
    }))
);

function handleLogout() {
  auth.logout();
  router.push({ name: "Login" });
}

function handleEditProfile() {
  showWarning("Work in progress");
}
</script>